module.exports = __webpack_public_path__ + "img/lectors.ba948f2a.png";